import { lazy, Suspense } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { useResolvedFacility } from "@/hooks/use-selected-facility";

// The live schedule (grid, editor, drag and drop) is its own chunk, loaded
// when the Schedule opens.
const SchedulePlanner = lazy(async () => ({ default: (await import("./schedule-planner")).SchedulePlanner }));

function Loading() {
  return (
    <>
      <Typography component="h1" sx={{ fontWeight: 700 }} variant="h4">
        Schedule
      </Typography>
      <Stack
        aria-live="polite"
        direction="row"
        role="status"
        spacing={1}
        sx={{ minHeight: 160, alignItems: "center", justifyContent: "center" }}
      >
        <CircularProgress size={20} />
        <Typography color="text.secondary" variant="body2">
          Loading schedule…
        </Typography>
      </Stack>
    </>
  );
}

export function CalendarWorkspace() {
  const { facility, isLoading } = useResolvedFacility();

  return (
    <Stack spacing={2.5} sx={{ px: { xs: 2, lg: 3 }, pt: { xs: 1.5, lg: 2 }, pb: 1.5 }}>
      {isLoading || !facility ? (
        <Loading />
      ) : (
        // The planner renders its own title row (Schedule, layouts, days).
        <Suspense fallback={<Loading />}>
          <SchedulePlanner facility={facility} key={facility.facility_id} />
        </Suspense>
      )}
    </Stack>
  );
}
